import { Pipe, PipeTransform } from '@angular/core';
import { FormFieldWrapper } from '../../shared/utils/form-utils';

@Pipe({
  name: 'formFieldFeedback'
})
export class FormFieldFeedbackPipe implements PipeTransform {

  transform(control: FormFieldWrapper<any> | null): string {
    if (!control?.errors || !control?.touched) return '';
    const errors = control.errors;

    if ('blank' in errors) return 'Campo em branco!';
    if ('required' in errors) return 'Campo obrigatório!';
    if ('email' in errors) return 'E-mail inválido!';
    if ('minlength' in errors) {
      const minLength = control.errors['minlength'].requiredLength;
      return `Mínimo de ${minLength} caracteres!`;
    }
    if ('maxlength' in errors) {
      const maxLength = control.errors['maxlength'].requiredLength;
      return `Máximo de ${maxLength} caracteres!`;
    }
    if ('pattern' in errors) return 'Formato inválido!';

    if ('passwordMismatch' in errors) return 'As senhas não coincidem!';

    if ('yearsLimitExceeded' in errors) {
      const yearsLimit = control.errors['yearsLimitExceeded'].yearsLimit;
      const bound = control.errors['yearsLimitExceeded'].isMax ? 'Máximo' : 'Mínimo';
      return `${bound} de ${yearsLimit} anos!`;
    }

    return 'Campo inválido!'
  }
}
